// extracted by mini-css-extract-plugin
module.exports = {"trailersWrapper":"rx","trailerHeader":"ry","trailers":"rz","trailer":"rA","imgWrapper":"rB","playWrapper":"rC","playImg":"rD","title":"rE","slipnslideArrow":"rF"};